import { abi } from 'thor-devkit';
// https://solidity.readthedocs.io/en/v0.5.5/control-structures.html#error-handling-assert-require-revert-and-exceptions
// 0x08c379a0
// Function selector for Error(string)
const errorSig = '0x08c379a0';
export function decodeRevertReason(data) {
    try {
        if (data.startsWith(errorSig)) {
            return abi.decodeParameter('string', '0x' + data.slice(errorSig.length));
        }
        return '';
    }
    catch (_a) {
        return '';
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV2ZXJ0LXJlYXNvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9yZXZlcnQtcmVhc29uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxhQUFhLENBQUE7QUFFakMsd0hBQXdIO0FBQ3hILGFBQWE7QUFDYixzQ0FBc0M7QUFFdEMsTUFBTSxRQUFRLEdBQUcsWUFBWSxDQUFBO0FBRTdCLE1BQU0sVUFBVSxrQkFBa0IsQ0FBQyxJQUFZO0lBQzNDLElBQUk7UUFDQSxJQUFJLElBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLEVBQUU7WUFDM0IsT0FBTyxHQUFHLENBQUMsZUFBZSxDQUFDLFFBQVEsRUFBRSxJQUFJLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQVcsQ0FBQTtTQUNyRjtRQUNELE9BQU8sRUFBRSxDQUFBO0tBQ1o7SUFBQyxXQUFNO1FBQ0osT0FBTyxFQUFFLENBQUE7S0FDWjtBQUNMLENBQUMifQ==